import LoadingStatus from 'enums/loadingStatus';
import { camelCaseObjectKeys } from 'utils/camelCase';

const articleSearchResultsElement = document.querySelector('[data-component="article-search-results-command"]');
const articleSearchResultsData = camelCaseObjectKeys(JSON.parse(articleSearchResultsElement.innerHTML));

const initialState = {
  fetchingArticlesStatus: LoadingStatus.Idle,
  fetchingArticlesCountsStatus: LoadingStatus.Idle,
  ...articleSearchResultsData
};

export default initialState;